import { CalendarItemType, CreateEventInput } from '@akin-home/amplify';
import { Event } from '@akin-home/events';
import { handleImageFieldsOnPost } from '@akin-home/images/frontend';
import {
  computeUntilDate,
  getUntilDateString,
  serializeRRule,
} from '@akin-home/recurrence';
import { JSONStringifySafe } from '@akin-home/utils/json';
import { UpdateEventInput } from '../types';

export const eventModelToCreateGrapqhl = async (
  e: Event
): Promise<CreateEventInput> => {
  const event = await handleImageFieldsOnPost(e, {
    habitatID: e.habitatID,
  });

  return {
    title: event.title,
    type: CalendarItemType.Event,
    emoji: event.emoji,
    location: event.location,
    habitatID: event.habitatID,
    start: event.start.toISOString(),
    end: event.end.toISOString(),
    notes: event.notes,
    allDay: event.allDay,
    checklist: JSON.stringify(event.checklist || []),
    todo: JSON.stringify(event.todo || []),
    participantIDS: event.participants?.map((p) => p.id as string),
    recurrence: event.recurrence && serializeRRule(event.recurrence),
    recurrenceUntil: event.recurrence
      ? computeUntilDate(event.recurrence).toISOString()
      : null,
    imageID: event.image?.id || null,
    imageURL: event.imageUrl || null,
    color: event.color,
    tags: JSON.stringify(event.tags || {}),
    reminders: JSONStringifySafe(event.reminders, '[]'),
  };
};

export const eventModelToUpdateData = async (
  e: Event
): Promise<UpdateEventInput> => {
  const event = await handleImageFieldsOnPost(e, {
    habitatID: e.habitatID,
  });

  return {
    ...event,
    id: event.id,
    start: event.start.toISOString(),
    end: event.end.toISOString(),
    recurrence: event.recurrence && serializeRRule(event.recurrence),
    recurrenceUntil: getUntilDateString(event.recurrence) || null,
  };
};

/** Data form get requests convert to a model */
export const eventDataToModel = (event: any): Event => ({
  ...event,
  start: new Date(event.start),
  end: new Date(event.end),
});
